export default (string:any)=>{
    const innerHTMLRegex:any = /<script\b[^>]*>(.*?)<\/script>/s;
    const innerHTML = string.match(innerHTMLRegex)[1]||"";
    return innerHTML
}